export const isMobileDevice = () => window.innerWidth <= 786;